import React from "react";

import { NotificationBall, Color } from "@ui/Atoms/NotificationBall";

import { TestWrapper } from "../TestWrapper";

interface Props {
  className?: string;
  color?: Color;
  total: number | null;
  testId?: string;
}
const TotalCounter = React.memo((props: Props): React.ReactElement | null => {
  if (!props.total) {
    return null;
  }

  return (
    <TestWrapper testId={props.testId}>
      <NotificationBall className={props.className} color={props.color}>
        {props.total}
      </NotificationBall>
    </TestWrapper>
  );
});

TotalCounter.displayName = "TotalCounter";

export { TotalCounter };
